module.exports = __webpack_public_path__ + "img/chevron-left.7f4fc4d7.svg";